import React, { FunctionComponent } from 'react';
import { II18n } from '../../../models';
import { BrassButtonShared, BrassButtonSharedProps } from './Button';
import { BrassIcon } from '../icon/Icon';
import { faDownload } from '@fortawesome/free-solid-svg-icons';

const BrassButtonDownload: FunctionComponent<BrassButtonSharedProps> = (
  props: BrassButtonSharedProps,
) => (
  <BrassButtonShared
    themeColor='primary'
    className='brass-button-download'
    labelKey='download'
    tooltipKey='clickToDownload'
    translations={translations}
    icon={<BrassIcon icon={faDownload} />}
    {...props}
  />
);

const translations: II18n = {
  es: {
    download: 'Descarregar',
    clickToDownload: 'Haga clic para descarregar',
  },
  enUS: {
    download: 'Download',
    clickToDownload: 'Click to download',
  },
  ptBR: {
    download: 'Download',
    clickToDownload: 'Clique para fazer o download',
  },
};

export { BrassButtonDownload };
